import { DefaultState } from 'store/types';

export const VIEW_GUEST_REQUEST = 'VIEW_GUEST_REQUEST';
export const VIEW_GUEST_SUCCESS = 'VIEW_GUEST_SUCCESS';
export const VIEW_GUEST_FAILURE = 'VIEW_GUEST_FAILURE';

export interface ViewGuestData {
  id: string;
  domainId: string;
  guestType: string;
  firstName: string;
  lastName: string;
  gender: string;
  email: string;
  phoneNumber: string;
}

export type ViewGuestState = DefaultState & {
  contents?: ViewGuestData;
};

interface ViewGuestRequest {
  type: typeof VIEW_GUEST_REQUEST;
}

interface ViewGuestSuccess {
  type: typeof VIEW_GUEST_SUCCESS;
  contents: ViewGuestData;
}

interface ViewGuestFailure {
  type: typeof VIEW_GUEST_FAILURE;
}

export type ViewGuestActionTypes = ViewGuestRequest | ViewGuestSuccess | ViewGuestFailure;
